/**
 * Per-scene composition picker. Three modes:
 *   - still_static   → held PNG (no motion, no fal.ai $$)
 *   - still_kenburns → slow zoom/pan over the still (no fal.ai $$)
 *   - video          → fal.ai animation ($$ per scene)
 *
 * Used in both the ScriptEditor (one per scene row) and the AutoVideo
 * summary card (a small inline group). Compact prop = pill-only labels.
 */

export const SCENE_MODE_OPTIONS = [
  { id: "still_static",   label: "Still",     hint: "Held image · free" },
  { id: "still_kenburns", label: "Ken Burns", hint: "Slow zoom/pan · free" },
  { id: "video",          label: "Video",     hint: "AI animation · $$" },
];

export const SCENE_MODE_LABELS = Object.fromEntries(
  SCENE_MODE_OPTIONS.map((o) => [o.id, o.label])
);

export default function SceneModePicker({
  value,
  onChange,
  disabled = false,
  compact = false,
  sceneIdx,
}) {
  const current = SCENE_MODE_OPTIONS.find((o) => o.id === value) ? value : "still_static";
  return (
    <div
      className={
        "inline-flex items-stretch rounded-sm border border-zinc-800 overflow-hidden " +
        (disabled ? "opacity-50 cursor-not-allowed" : "")
      }
      role="group"
      aria-label={sceneIdx != null ? `Scene ${sceneIdx + 1} composition` : "Scene composition"}
      data-testid={sceneIdx != null ? `scene-mode-picker-${sceneIdx}` : "scene-mode-picker"}
    >
      {SCENE_MODE_OPTIONS.map((opt) => {
        const active = current === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && onChange(opt.id)}
            title={opt.hint}
            data-testid={
              sceneIdx != null
                ? `scene-mode-${sceneIdx}-${opt.id}`
                : `scene-mode-btn-${opt.id}`
            }
            data-active={active ? "true" : "false"}
            className={
              "font-mono uppercase tracking-[0.2em] transition-colors border-r border-zinc-800 last:border-r-0 " +
              (compact ? "text-[9px] px-2 py-1 " : "text-[10px] px-2.5 py-1.5 ") +
              (active
                ? opt.id === "video"
                  ? "bg-yellow-400 text-black font-bold"
                  : "bg-yellow-400/15 text-yellow-300 font-bold"
                : "text-zinc-400 hover:text-yellow-300 hover:bg-zinc-900")
            }
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
